import {findDOMNode} from 'react-dom';
import applyConditionalClasses from 'rlink-apply-conditional-classes';

import {createElement, PropTypes, PureComponent} from 'rlink-react';
import {onNextAnimationFrameAfterScroll, ElementCornerScrollPositionHelper} from 'rlink-transitions/ScrollEffect';
import {mergeStaticOptions} from 'rlink-utils/object';


const QUARTS = [1, 2, 3, 4];
const SIDES = ['top', 'bottom'];

export default class LegacyScrollTransition extends PureComponent {

  componentDidMount () {
    let [element, scrollHelpers] = this.updateScrollHandler();
    this.updateTransitionClasses(element, scrollHelpers);
  }

  componentDidUpdate () {
    this.disposable && this.disposable.dispose();
    this.updateScrollHandler();
  }

  componentWillUnmount () {
    this.disposable && this.disposable.dispose();
  }

  getScrollHelper (element, side) {
    return new ElementCornerScrollPositionHelper(element, side, 'left');
  }

  updateScrollHandler () {
    let element = findDOMNode(this);
    let scrollHelpers = {
      topPoint: this.getScrollHelper(element, 'top'),
      bottomPoint: this.getScrollHelper(element, 'bottom'),
    };
    this.disposable = onNextAnimationFrameAfterScroll(element, () => {
      this.updateTransitionClasses(element, scrollHelpers);
    });
    return [element, scrollHelpers];
  }

  updateTransitionClasses (element, scrollHelpers) {
    let css = this.props.css;
    let classes = {
      'scroll-visible': scrollHelpers.topPoint.isVisible()
        || scrollHelpers.bottomPoint.isVisible(),
    };
    for (let side of SIDES) {
      let point = scrollHelpers[`${side}Point`];
      classes[`${side}-viewport`] = point[side]() < 0;
      let currentQuart = Math.floor(point[`${side}Percentage`]() * 4) + 1;

      if (side === 'bottom') {
        currentQuart = Math.min(currentQuart, QUARTS.length);
      }

      for (let quart of QUARTS) {
        classes[`${side}-quart-${quart}`] = quart === currentQuart;
      }

      if (side === 'top') {
        if (point.topPercentage() < 0) {
          this.dispatchEventOnce(element, 'reached-top-viewport');
        } else if (currentQuart in QUARTS) {
          this.dispatchEventOnce(element, `reached-top-quart-${currentQuart}`);
        } else if (point.topPercentage() > 1) {
          this.dispatchEventOnce(element, 'reached-top-out-of-bounds');
        }
      } else if (side === 'bottom') {
        if (point.bottomPercentage() > 1) {
          this.dispatchEventOnce(element, 'reached-bottom-out-of-bounds');
        }
      }
    }
    let conditionalClasses = {};
    for (let [className, isSet] of Object.entries(classes)) {
      conditionalClasses[css[className]] = isSet;
      if (isSet) {
        element.classList.add(css[`${className}-once`]);
      }
    }
    applyConditionalClasses(element, conditionalClasses);
  }

  dispatchEventOnce (element, eventName) {
    if (element.getAttribute('data-last-event-sent') !== eventName && element.dispatchEvent) {
      let event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, false, false, {});
      element.dispatchEvent(event);
      element.classList.remove(this.props.css[`${element.getAttribute('data-last-event-sent')}`]);
      element.setAttribute('data-last-event-sent', eventName);
      element.classList.add(this.props.css[`${eventName}`]);
    }
  }
  render () {
    return this.props.children;
  }
}


LegacyScrollTransition.propTypes = {
  children: PropTypes.node,
  css: PropTypes.objectOf(PropTypes.string),
};

export class LegacyCoveringScrollTransition extends LegacyScrollTransition {
  getScrollHelper (element, side) {
    if (side === 'top') {
      let coveringElement = document.getElementsByClassName(this.props.coveringElementClassName)[0];
      return new ElementCornerScrollPositionHelper(coveringElement, 'bottom', 'left');
    } else {
      return super.getScrollHelper(element, side);
    }
  }
}

mergeStaticOptions(LegacyCoveringScrollTransition, {
  propTypes: {
    coveringElementClassName: PropTypes.string,
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-transitions/LegacyScrollTransition.jsx